var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { debugRoot } from '../../../../styles/debugStyles';
var listStyles = {
    root: function (_a) {
        var props = _a.props;
        var as = props.as, debug = props.debug;
        return __assign({}, (debug && debugRoot()), ((as === 'ul' || as === 'ol') && {
            listStyle: 'none',
            display: 'block',
            padding: 0,
            margin: 0,
        }));
    },
};
export default listStyles;
